import { Sparkle } from "lucide-react";

export const Marquee = ({ t }) => {
  const items = [...t.marquee, ...t.marquee];
  return (
    <div
      data-testid="marquee-band"
      className="marquee-band relative overflow-hidden border-y border-[#0A272C] bg-[#0A272C] py-7"
    >
      <div className="animate-marquee flex whitespace-nowrap items-center gap-10 w-max">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-syne text-lg sm:text-xl font-bold uppercase tracking-tight text-slate-200">
              {item}
            </span>
            <Sparkle size={16} className="text-[#A8DAE0] shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
};
